import { apiSlice } from "../../../_api/apiSlice";
import { apiRoutes } from "../../../_config/apiRoutes";

export const bundlesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllBundles: builder.query({
      query: (params) => ({
        url: apiRoutes.bundles.get.path,
        method: apiRoutes.bundles.get.reqType,
        params,
      }),
      providesTags: ["Bundles"],
    }),
    createBundle: builder.mutation({
      query: (data) => ({
        url: apiRoutes.bundles.create.path,
        method: apiRoutes.bundles.create.reqType,
        body: data,
      }),
      // Without this, a freshly-created bundle (quick-create on the Plan
      // form, or "+ Add new bundle" in ManageBundlesModal) is invisible
      // everywhere else in the UI (Plan form's own bundle picker, PlanPage's
      // bundle tabs) for up to getAllBundles' 60s default cache lifetime -
      // the POST succeeds but nothing tells RTK Query the list is stale.
      invalidatesTags: ["Bundles"],
    }),
    updateBundle: builder.mutation({
      query: (data) => ({
        url: apiRoutes.bundles.edit.path,
        method: apiRoutes.bundles.edit.reqType,
        body: data,
      }),
      invalidatesTags: ["Bundles"],
    }),
    changePlanOrder: builder.mutation({
      query: (data) => ({
        url: apiRoutes.bundles.changePlanOrder.path,
        method: apiRoutes.bundles.changePlanOrder.reqType,
        body: data,
      }),
      invalidatesTags: ["Bundles"],
    }),
  }),
});

export const {
  useGetAllBundlesQuery,
  useCreateBundleMutation,
  useUpdateBundleMutation,
  useChangePlanOrderMutation
} = bundlesApiSlice;
